import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/shared/hooks/use-theme";
import { cn } from "@/shared/lib/cn";

/**
 * Segmented light/dark toggle. Inspired by macOS theme picker.
 * Two pressed-state buttons; aria-pressed reflects current theme.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();
  return (
    <fieldset
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-border bg-muted p-1",
        className,
      )}
    >
      <legend className="sr-only">Theme</legend>
      <button
        type="button"
        aria-pressed={theme === "light"}
        aria-label="Light theme"
        onClick={() => setTheme("light")}
        className={cn(
          "inline-flex size-7 items-center justify-center rounded-full text-text-tertiary transition-colors",
          "hover:text-foreground",
          theme === "light" && "bg-card text-foreground shadow-sm",
        )}
      >
        <Sun className="size-4" />
      </button>
      <button
        type="button"
        aria-pressed={theme === "dark"}
        aria-label="Dark theme"
        onClick={() => setTheme("dark")}
        className={cn(
          "inline-flex size-7 items-center justify-center rounded-full text-text-tertiary transition-colors",
          "hover:text-foreground",
          theme === "dark" && "bg-card text-foreground shadow-sm",
        )}
      >
        <Moon className="size-4" />
      </button>
    </fieldset>
  );
}
